/**
 * Recipe Campaign - One Side Scroll Takeover Component
 */

import { defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';

import { type App } from '~/app';


const pinia = createPinia();

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Recipe Campaign - One Side Scroll Takeover Component');
    app.vueApp.component('recipe-campaign-one-side-scroll-takeover', defineAsyncComponent(async () => import("./RecipeCampaignOneSideScrollTakeover.vue")));

    app.vueApp.use(pinia); // State Management for VueJS - https://pinia.esm.dev/
    console.log('Recipe Campaign - One Side Scroll Takeover Component Initialised');
};
